import React from 'react';

export function BlockLoading() {
  return (
    <div>
      <div className="ph-big bg-loading"></div>
      <div className="ph-text-full bg-loading mt-2"></div>
      <div className="ph-text-full bg-loading mt-2"></div>
      <div className="ph-text-full bg-loading mt-2"></div>
      <div className="ph-text bg-loading mt-2"></div>
      <div className="ph-big bg-loading mt-4"></div>
      <div className="ph-text-full bg-loading mt-2"></div>
      <div className="ph-text-full bg-loading mt-2"></div>
      <div className="ph-text bg-loading mt-2"></div>
    </div>
  );
}
